const MIN_SEARCH_TOKEN_LENGTH = 2;

export const normalizeDiscoverSearchText = (value: string | null | undefined): string =>
  (value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const getDiscoverSearchQueryToken = (
  query: string | null | undefined
): string | null => {
  const terms = normalizeDiscoverSearchText(query)
    .split(" ")
    .filter((term) => term.length >= MIN_SEARCH_TOKEN_LENGTH);

  if (!terms.length) {
    return null;
  }

  return [...terms].sort((left, right) => right.length - left.length)[0];
};

export const discoverTextMatchesSearchQuery = (
  text: string,
  query: string | null | undefined
): boolean => {
  const terms = normalizeDiscoverSearchText(query)
    .split(" ")
    .filter((term) => term.length >= MIN_SEARCH_TOKEN_LENGTH);

  if (!terms.length) {
    return true;
  }

  const haystack = normalizeDiscoverSearchText(text);
  return terms.every((term) => haystack.includes(term));
};
